const zhTW = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': '探索來源名稱',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': '使用者 Id',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Service Now Url',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': '密碼',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': '無效 Url',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': '探索頻率',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    '提示使用者回答以知識為基礎的驗證 (KBA) 問題。',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    '透過其中一個熱門的探索來源，探索應用程式和工作負載。您將享有許多優勢，例如預先填入的詳細資料、優先建議，以及上線狀態的完整檢視。',
  'INTEGRATIONS.DISCOVERY.BACK': '上一步',
  'INTEGRATIONS.DISCOVERY.TITLE': '設定探索',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': '即將推出...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': '深入了解',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    '輸入應用程式憑證，來建立連線。順利連線後，您就能夠匯入資料。',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING': '載入頁面時發生錯誤。',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    '嘗試重新整理，或稍後回來查看。如果問題持續發生，請聯絡系統管理員。',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': '重新載入',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title': '連線設定',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI 類別***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title': '屬性對應',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title': '連線詳細資料',
  'INTEGRATIONS.BUTTON.SAVE': '儲存',
  'INTEGRATIONS.DISCOVERY.SELECT': '選取',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': '建立新連線',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': '使用此連線',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow 已儲存!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    '已成功測試和儲存與探索來源 ServiceNow 的連線。匯入資料，來完成探索的設定。您可以略過...',
  'INTEGRATIONS.DISCOVERY.IMPORT': '匯入資產',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': '暫時略過',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE': '匯入一旦開始，就無法取消',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': '為我提供引導',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': '選取現有的連線',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': '連線名稱',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    '我們探索到 {total, plural, one {} other {#} 個}現有的連線組態:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': '開始匯入',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA': '從 Excel 檔案匯入資料。請稍等...',
  'INTEGRATIONS.TRY.AGAIN': '再試一次',
  'INTEGRATIONS.CLOSE': '關閉',
  'INTEGRATIONS.ERROR.CONNECTION': '連線錯誤。請再試一次。',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    '您可以在等待時離開此頁面。我們會在程序完成時通知您。',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': '匯入探索來源',
  'INTEGRATIONS.FILEUPLOAD.HEADING': '從檔案匯入探索來源',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': '下載範例檔案',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': '探索來源名稱',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': '輸入檔名',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    '請輸入有效的名稱。僅允許字母、數字和特定符號。',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': '正在上傳...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': '繼續',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    '以下是來自上傳 XLSX 檔案中的前 10 筆記錄。',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER': '遺失必要的標頭',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX': '偵測到欄錯誤',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    '請修正問題，再繼續資料匯入。',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': '從匯入中排除',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE': '應用程式上線確認',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    '我們已識別應用程式類型。請確認這是否是您要上線的正確應用程式類型。',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    '您要上線的應用程式類型為 {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    '不，從應用程式清單中選取',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM': '是，我要上線',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': '整合',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': '新增整合',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': '找不到以下項目的結果:',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': '否',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': '找到整合。',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': '沒有可用的隱藏整合。',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': '探索到的應用程式',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': '擁有者:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': '前次探索時間:',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': '連線失敗',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': '使用者具有存取權',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': '探索來源',
  'INTEGRATIONS.BUTTON.ENABLE': '啟用',
  'INTEGRATIONS.BUTTON.DISABLE': '停用',
  'INTEGRATIONS.ENABLING': '啟用',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': '探索',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': '重新上傳',
  'INTEGRATIONS.DASHBOARD.ONBOARD': '上線',
  'INTEGRATIONS.DASHBOARD.HIDE': '隱藏',
  'INTEGRATIONS.DASHBOARD.UNHIDE': '取消隱藏',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': '探索組態索引標籤',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    '是否要捨棄未儲存的變更?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    '您沒有未儲存的變更。如果繼續，變更將會遺失。',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': '捨棄變更',
  'INTEGRATIONS.BUTTON.CANCEL': '取消',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': '儲存錯誤',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': '返回前一頁',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': '應用程式圖示',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': '手動執行',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': '停用失敗',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': '啟用失敗',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION': '已成功停用。',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION': '已成功啟用。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    '目前正在匯入另一個項目。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    '另一個程序目前正在匯入資產。請稍後再試一次。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': '匯入失敗',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': '從 ServiceNow 中匯入資產',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    '您可以在等待時離開此頁面。我們會在程序完成時通知您。',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL': '新增屬性對應列',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': '新增屬性',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(空白)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': '刪除此對應',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow 欄位',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt 欄位',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW': '搜尋 ServiceNow 屬性',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': '搜尋 Saviynt 屬性',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(自訂)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': '儲存失敗',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': '排程組態',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': '在 UTC {timeLabel}。',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': '重複時間',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': '在每幾天重複',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': '每當以下時間時重複:',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL': '輸入間隔',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    '重複間隔，以天數、週數或月份數表示',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': '天',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': '週',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': '月',
  'INTEGRATIONS.DAYS.SUN': '週日',
  'INTEGRATIONS.DAYS.MON': '週一',
  'INTEGRATIONS.DAYS.TUE': '週二',
  'INTEGRATIONS.DAYS.WED': '週三',
  'INTEGRATIONS.DAYS.THU': '週四',
  'INTEGRATIONS.DAYS.FRI': '週五',
  'INTEGRATIONS.DAYS.SAT': '週六',
  'INTEGRATIONS.BUTTON.DISABLING': '停用中',
  'INTEGRATIONS.BUTTON.SAVED': '已儲存',
  'INTEGRATIONS.BUTTON.SAVING': '儲存中',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': '您確定要停用嗎 ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    '停用探索來源後，資產匯入程序將會停止，您就無法設定此來源。',
  'INTEGRATIONS.DISCOVERY.HERE': '此處',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    '已成功建立探索來源，但與 ServiceNow 的連線失敗。若要開始匯入資產，請更新探索來源組態頁面上的連線詳細資料 ',
};

export default zhTW;
